import { useEffect, useState } from "react";
import api from "@/lib/api";
import LegalPage from "@/components/LegalPage";

export default function Termos() {
    const [c, setC] = useState(null);
    useEffect(() => {
        api.get("/pages/termos").then((r) => setC(r.data?.content)).catch(() => {});
    }, []);
    if (!c) return null;
    return (
        <LegalPage
            eyebrow={c.eyebrow || "Documentos"}
            title={c.title || "Termos de uso"}
            lastUpdated={c.last_updated}
            testIdPrefix="terms"
            sections={c.sections || []}
        />
    );
}
